import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import convertToExcel from "../../../components/ExportToExcel";

const Customers = (props) => {
  const frmRef = useRef({});
  const [data, setData] = useState([]);
  const [employeeData, setEmployeeData] = useState([]);

  const { sendRequest: getEmp } = useHttp();

  useEffect(() => {
    getEmp(
      {
        url: `/api/fillEmployeeForReortwithCase/?useCase=Sales&empId=${localStorage.getItem(
          "empId"
        )}&orgId=${localStorage.getItem("orgId")} `,
      },
      (data) => {
        console.log("emp", data);
        var emplist = data;

        setEmployeeData(emplist);
        
      }
    );
  }, [getEmp]);

  const { sendRequest: getCustomer } = useHttp();

  useEffect(() => {
    getCustomer(
      {
        url: `/api/customer/?orgId=${localStorage.getItem(
          "orgId"
        )}&empId=${localStorage.getItem("empId")}`,
      },
      (res) => {
        if (res) {
          setData(res);
          // //console.log(res);
        }
      }
    );
  }, [getCustomer]);

  const handleEmpChange = (e) => {
    const id = parseInt(e.target.value);
    if (id) {
      getCustomer(
        {
          url: `/api/customer/?orgId=${localStorage.getItem(
            "orgId"
          )}&fieldExecutiveId=${id}`,
        },
        (res) => {
          if (res) {
            setData(res);
          }
        }
      );
    }
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fieldsToExport = [
    "customerCode",
    "name",
    "contactPersonName",
    "fieldExecutiveName",
    "emailId",
    "workContactNumber",
    "paymentTermsInDays",
  ];

  const customHeaders = [
    "Customer No",
    "Customer Name",
    "Contact Person Name",
    "Field Executive Name",
    "Email",
    "Contact Number",
    "Payment Terms In Days",
  ];

  const handleExportExcel = () => {
    const filename = "Customers.xlsx";
    const transformedData = data.map((item) => ({
      ...item,
      contactPersonName: item.contactPersonDetails[0]?.name || "",
    }));

    convertToExcel(transformedData, fieldsToExport, filename, customHeaders);
  };

  return (
    <>
      <div className="content-wrapper">
        <section className="content">
          <div className="container-fluid">
        
            <div className="row">
              {" "}
              <h3 className="card-title mx-3 my-1">Customers</h3>
            </div>
            <div className="text-right my-2">
              <button
                type="button"
                className="btn btn-sm btn-warning"
                onClick={handleExportExcel}
              >
                <i className="fas fa-file-excel"></i>
              </button>
            </div>
            <div className="row">
              <div className="col-md-3 mx-3 my-2">
                <label htmlFor={"executive_officer"}>{"Field Executive"}</label>
                <select
                  id="emp_id"
                  className="form-control"
                  ref={(el) => (frmRef.current["emp_id"] = el)}
                  onChange={handleEmpChange}
                >
                  <option value="">Select</option>
                  {employeeData &&
                    employeeData.map((x) => (
                      <option key={x.userId} value={x.userId}>
                        {x.employeeName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-3 mx-3 my-4">
                <button className="btn btn-sm btn-primary">Submit</button>
              </div>
            </div>
          </div>

          <hr />
        </section>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <table className="table table-bordered  text-center table-sm">
                      <thead>
                        <tr className="table-header">
                          <th>Customer No</th>
                          <th>Customer Name</th>
                          <th>Contact Person Name</th>
                          <th>Field Executive Name</th>
                          <th>Email</th>
                          <th>Contact Number</th>
                          <th>Payment Terms in Days</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((x, i) => {
                            return (
                              <tr key={i} className="tablerowview">
                                <td>{x.customerCode}</td>
                                <td>{x.name}</td>
                                <td>{x.contactPersonDetails[0].name}</td>
                                <td>{x.fieldExecutiveName}</td>
                                <td>{x.emailId}</td>
                                <td>{x.workContactNumber}</td>
                                <td>{x.paymentTermsInDays}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>

                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Customers;
